import { createCurrentModule, createInjectableCallback, createInjectableSelector } from '@beef/redux';
import { emptyObj } from '@beef/utils';
export var selectHeader = createInjectableSelector();
export var selectHeaderCommonData = function selectHeaderCommonData(state) {
  return selectHeader(state).common;
};
export var selectAdditionalLinks = function selectAdditionalLinks(state) {
  return selectHeaderCommonData(state).additionalLinks || emptyObj;
};
export var selectLogo = function selectLogo(state) {
  return selectHeaderCommonData(state).logo || emptyObj;
};
export var selectAuthFlag = function selectAuthFlag(state) {
  return Boolean(selectHeaderCommonData(state).auth.user);
};
export var loginClick = createInjectableCallback(Symbol('login'));
export var regionClick = createInjectableCallback(Symbol('region'));
export var selectCurrentEnv = function selectCurrentEnv(state) {
  return selectHeaderCommonData(state).env;
};
export var HeaderModule = createCurrentModule({
  selectData: selectHeader,
  onLoginClick: loginClick,
  onRegionClick: regionClick
});